export const valoresExibidosOffCanvasContratos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface',
  moduloSisAf: 'Módulo',
  tipoTask: 'Tipo de Task',
  responsavel: 'Responsável',
  dataEntrada: 'Data de Início',
  dataFinalizacao: 'Data Finalização',
  diasDev: 'Total de dias',
  funcionalidade: 'Funcionalidade',
  descricao: 'Descrição',
  complexidade: 'Complexidade',
  reaproveitamentoCodigo: 'Reaprov. Código',
  pontosFuncionalidade: 'Level (0 a 100)',
  statusDesenvolvimento: 'Status Dev',
  level: 'Level',
};

export const offCanvasProgramacao: Record<string, string> = {
  id: 'ID da Programação',
  produtoFarmaceutico: 'Produto Farmacêutico',
  obm: 'OBM',
  separadorProduto: '',
  listaPacienteObrigatoria: 'Lista de Pacientes Obrigatória?',
  modeloLista: 'Lista Modelo',
  upload: 'Lista de Pacientes',
  download: 'Lista Analisada',
  ses_pacientes: 'Pacientes Informados',
  pacientesValidados: 'Pacientes Validados',
  separadorPacientes: '',
  ses_consumo_pacientes: 'Consumo Estimado dos Pacientes Aprovados',
  ses_estoque: 'Estoque SES',
  ses_necessidade: 'Solicitação SES',
  separadorDemanda: '',
  total_aprovado: 'Total Aprovado MS',
  criterioAprovacao: 'Critério de Aprovação',
  total_enviado: 'Total Enviado',
  total_entregue: 'Total Entregue',
  separadorRegra: '',
  regraValidacao: 'Regra de validação da lista de pacientes',
};

export const headersProgEspecializado = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Ano', width: 5, key: 'componenteAf' },
  { text: 'Trimestre', width: 5, key: 'modalidadeAquisicao' },
  { text: 'Status', width: 8, key: 'statusContrato' },
  { text: 'N Produtos', width: 8, key: 'modalidadeAquisicao' },
  { text: 'Total Solicitado', width: 8, key: 'modalidadeAquisicao' },
  { text: 'Total Aprovado', width: 8, key: 'modalidadeAquisicao' },
  { text: 'Total Entregue', width: 8, key: 'modalidadeAquisicao' },
  { text: '% Entregue', width: 8, key: 'modalidadeAquisicao' },
];

export const headersProgEspecializadoResumo = [
  { text: '', width: 1, key: '' },
  { text: 'ID Programação', width: 5, key: 'id' },
  { text: 'Produto Farmacêutico', width: 20, key: 'produtoFarmaceutico' },
  { text: 'Total Demandado', width: 8, key: 'total_aprovado' },
  { text: 'Total Aprovado', width: 8, key: 'total_aprovado' },
  { text: 'Total Enviado', width: 8, key: 'total_enviado' },
  { text: '% Entregue', width: 8, key: 'total_entregue' },
  { text: 'Lista de Pacientes', width: 8, key: 'upload' },
];

export const headersNotificacoes = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 5, key: 'id' },
  { text: 'Status', width: 12, key: 'saldo' },
  { text: 'Data', width: 10, key: 'itemProduto' },
  { text: 'Tipo', width: 12, key: 'itemTipoCota' },
  { text: 'Assunto', width: 60, key: 'saldo' },
];

export const headersItensContratos = [
  { text: '', width: 1, key: '' },
  { text: 'Item', width: 2, key: 'id' },
  { text: 'Tipo Cota', width: 10, key: 'itemTipoCota' },
  { text: 'Produto', width: 75, key: 'itemProduto' },
  { text: 'Saldo', width: 10, key: 'saldo' },
];

export const fieldObjectContratos = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
